import { UrlInputType } from '../InputTypes';
import { makeOperator } from './Operator';
import isString from 'transmute/isString';
import { defaultUtmParameters, isValidUtmParameters } from '../../utils/urlUtils';
export default makeOperator({
  inputType: UrlInputType,
  name: 'PageViewNotEqual',
  isRefinable: true,
  isRefinableExtra: true,
  values: [{
    name: 'value',
    isValid: isString
  }, {
    name: 'enableTracking',
    defaultValue: false
  }, {
    name: 'utmBase',
    defaultValue: '',
    isValid: isString
  }, {
    name: 'utmParameters',
    defaultValue: defaultUtmParameters,
    isValid: isValidUtmParameters
  }]
});